<template>
  <div>
    <Header />

    <div class="nav-scroller bg-white shadow-sm">
      <nav class="nav nav-underline">
        <a class="nav-link" href="https://aopa.ru/">АОПА-Россия</a>
        <a class="nav-link" href="https://maps.aopa.ru/" target="_blank">База аэродромов</a>
        <a class="nav-link" href="https://tracker.aopa.ru" target="_blank">АОПА-Трекер</a>
        <router-link to="PartnerPage" class="nav-link" v-if="$store.getters.getUserData.memberInfo && $store.getters.getUserData.memberInfo.partnerCode">Страница партнёра</router-link>
        <router-link to="Entrance" class="nav-link" v-if="!$store.getters.getUserData.memberInfo || ($store.getters.getUserData.memberInfo.status !== 'active_member')">Оформление членства</router-link>
        <a class="nav-link ml-auto" href="https://tracker.aopa.ru/auth/logout/aHR0cHM6Ly9hb3BhLnJ1Lw==">Выход</a>
      </nav>
    </div>

    <div class="container-fluid">
      <slot></slot> <!-- сюда вставляется контент страницы -->
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Header,
    Footer
  }
}
</script>
